import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面未找到 - 电影天堂",
    description:
      "抱歉，你访问的页面不存在或已调整。你可以返回电影天堂首页，继续浏览最新电影资源与影视资讯。",
    keywords: "404,页面未找到,电影天堂",
  });

  return (
    <div className="mx-auto flex w-full max-w-[720px] flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
        <i className="ri-film-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-primary-500 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这个页面走丢啦
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已经被调整。别担心，回到首页继续浏览最新电影资源与影视资讯吧。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-apps-2-line"></i>
          浏览全部影片
        </Link>
      </div>
    </div>
  );
}